import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HELPER_DEBOUNCE_TIME } from '@shared/tokens';
import {
  AddAllCountriesToListAction,
  GetAllCountriesAction,
  ActionTypes as HelperActionTypes
} from '@store/helpers/helper.actions';
import { HelperService } from '@store/helpers/helper.service';
import { catchError, debounceTime, map, of, switchMap } from 'rxjs';

export const loadAllCountries$ = createEffect(
  (
    actions$ = inject(Actions),
    helperDebounceTime = inject(HELPER_DEBOUNCE_TIME, { optional: true }),
    helperService = inject(HelperService)
  ) =>
    actions$.pipe(
      ofType<GetAllCountriesAction>(HelperActionTypes.GET_ALL_COUNTRIES),
      debounceTime(helperDebounceTime),
      switchMap(() => {
        return helperService.getListOfCountries().pipe(
          map((allCountries: string[]) => new AddAllCountriesToListAction(allCountries)),
          catchError(() => of(new AddAllCountriesToListAction([])))
        );
      })
    ),
  { functional: true }
);
